/* =====================================================================
   ZAPIET QTY LIMITER – FINAL STABLE BUILD (No Lag / No Refresh)
===================================================================== */

(function(){
console.log("%c[QTY LIMITER ENABLED]","background:#111;color:#0f0;padding:4px");

/* ==================== CONFIG ACCESS ==================== */

const CFG = () => window.QTY_LIMITER_CONFIG || {};

function getRestaurant(){
    try { return String(window.ZapietEats?.getSelectedRestaurant?.()?.id || ""); }
    catch(e){ return ""; }
}

function getMinQty(variantId){
    if(!variantId) return null;
    variantId = String(variantId);

    const cfg = CFG();
    const restCfg = cfg.restaurants?.[getRestaurant()] || {};
    const fallback = cfg.fallback || {};

    return restCfg[variantId] ?? fallback[variantId] ?? null;
}

/* ==================== UI BADGES ==================== */

function wrap(input){
    if(!input) return null;
    let w=input.closest(".ql-wrap");
    if(!w){
        w=document.createElement("span");
        w.className="ql-wrap";
        w.style="display:inline-flex;align-items:center;gap:6px;";
        input.parentNode.insertBefore(w,input);
        w.appendChild(input);
    }
    return w;
}

function badge(input,text){
    const w=wrap(input);
    let b=w.querySelector(".ql-badge");
    if(!b){
        b=document.createElement("span");
        b.className="ql-badge";
        b.style="font-size:11px;padding:3px 6px;border-radius:10px;background:#FFE59D;border:1px solid #C8A200;font-weight:600;color:#000;";
        w.appendChild(b);
    }
    b.textContent=text;
    b.style.display="inline-block";
}

function hideBadge(input){
    const b=input?.closest(".ql-wrap")?.querySelector(".ql-badge");
    if(b) b.style.display="none";
}

/* ==================== BUTTON CONTROL ==================== */

function setATC(btn,txt,disabled){
    if(!btn) return;
    btn.disabled = disabled;
    btn.style.opacity = disabled?"0.5":"1";
    btn.style.pointerEvents = disabled?"none":"auto";
    btn.innerText = txt;
}

function lockCheckout(state){
    document.querySelectorAll(`
        button[name="checkout"], #checkout,
        form[action*="/checkout"] button[type="submit"],
        .t4s-cart-checkout, .t4s-checkout,
        .cart__checkout, .cart__submit,
        button.checkout, button[class*="checkout"],
        a[href*="/checkout"]
    `).forEach(btn=>{
        btn.disabled = state;
        btn.style.opacity = state?"0.4":"1";
        btn.style.pointerEvents = state?"none":"auto";
    });
}

/* ==================== PDP LIMITER ==================== */

function initPDP(){
document.querySelectorAll('form[action*="/cart/add"],form[action="/cart/add"]').forEach(form=>{
    if(form.dataset._qlPDP) return; form.dataset._qlPDP="1";

    const id=form.querySelector('[name="id"]');
    const qty=form.querySelector('input[name="quantity"],input[name="qty"],input[type="number"],.t4s-qty-input');
    const atc=form.querySelector('button[type="submit"],.t4s-add-to-cart,.t4s-product-add-btn');

    if(!id||!qty||!atc) return;
    if(!atc.dataset.orig) atc.dataset.orig=atc.innerText.trim();

    function enforce(){
        const min=getMinQty(id.value);
        const val=+qty.value||0;

        if(!min){ hideBadge(qty); setATC(atc,atc.dataset.orig,false); return; }

        if(val < min){
            badge(qty,`MINIMUM OF ${min}`);
            setATC(atc,`MINIMUM OF ${min}`,true);
        } else {
            hideBadge(qty);
            setATC(atc,atc.dataset.orig,false);
        }
    }

    enforce();
    qty.addEventListener("input",enforce);
    qty.addEventListener("change",enforce);
});
}

/* ==================== CART LIMITER (Instant + Fast) ==================== */

function initCart(){

const INPUTS = ()=>[...document.querySelectorAll('input[name^="updates"], .t4s-quantity-input,input.qty')];
const CART = document.querySelector('#CartContainer,.cart__items,.t4s-cart,form[action="/cart"],#MainContent') || document.body;

function evaluate(){
    const items = INPUTS();
    if(!items.length){ lockCheckout(false); return; }

    let block=false;

    items.forEach(inp=>{
        const id=(inp.dataset.id||inp.name||"").match(/\d+/)?.[0];
        const min=getMinQty(id);
        const val=+inp.value||0;

        if(min && val < min){ badge(inp,`MIN ${min}`); block=true; }
        else hideBadge(inp);
    });

    lockCheckout(block);
}

/* throttle — fast, no slow header */
let t;
const run =()=>{ clearTimeout(t); t=setTimeout(evaluate,90); };

evaluate();

/* Live triggers */
document.addEventListener("input",run,{passive:true});
document.addEventListener("change",run,{passive:true});
document.addEventListener("t4s:ajaxComplete",run);
document.addEventListener("shopify:section:load",run);
document.addEventListener("cart:refresh",run);

/* Mutation watcher ONLY in cart — header safe */
new MutationObserver(run).observe(CART,{childList:true,subtree:true});

}

/* ==================== INIT ==================== */

function start(){ initPDP(); initCart(); }

document.addEventListener("DOMContentLoaded",()=>setTimeout(start,180));
document.addEventListener("zapieteats:ready",()=>setTimeout(start,180));
document.addEventListener("zapieteats:change",()=>setTimeout(start,180));

})();
